<template>
    <div class="page-wrapper">
        <Header/>
        <div class="wrapper">
            <div class="page">
                <div class="container">
                    <div class="article-page">
                        <router-link :to="{name: 'Blog'}" class="back">
                            <i class="fa fa-long-arrow-left" aria-hidden="true"></i>назад
                        </router-link>
                        <template v-if="!!article">
                            <div class="page-title">{{article.header}}</div>
                            <div class="date">{{formatDate(article.date)}}</div>

                            <div class="article-noaccess-msg" v-if="onlyProAccess || onlyPaidAccess || onlyAuthAccess">
                                <template v-if="onlyProAccess">
                                    Для просмотра этой статьи подключите <router-link :to="{name: 'Tariff'}">тариф PRO</router-link>.
                                </template>
                                <template v-else-if="onlyPaidAccess">
                                    Для просмотра этой статьи подключите <router-link :to="{name: 'Tariff'}">тариф Базовый или PRO</router-link>.
                                </template>
                                <template v-else>
                                    Для просмотра этой статьи необходима <router-link :to="{name: 'Login'}">авторизация</router-link>
                                </template>
                            </div>
                            <template v-else>
                                <div class="article" v-html="article.textContent"/>
                                <div class="soc-share-btns">
                                    <div>Поделиться статьей</div>
                                    <button class="btn-vk" @click="shareVk"><i class="fa fa-vk" aria-hidden="true"></i>
                                    </button>
                                    <button class="btn-fb" @click="shareFb"><i class="fa fa-facebook"
                                                                               aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
            <div class=" page-buffer "></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import constants from '@/constants';
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import moment from 'moment';
    import Share from '@/share';

    export default {
        name: "Article",

        components: {
            Header, Footer
        },

        metaInfo() {
            return this.metaInfo;
        },

        data() {
            return {
                article: null,

                defaultArticleImage: require('@/image/default_article_image.jpg')
            }
        },

        computed: {
            metaInfo() {
                if (!!this.article) {
                    return {
                        title: `Astrodesign - ${this.article.header}`,
                        meta: [
                            {'http-equiv': 'Content-Type', content: 'text/html; charset=UTF-8'},
                            {property: 'og:url', content: this.articleUrl},
                            {property: 'og:type', content: 'website'},
                            {property: 'og:title', content: this.article.header},
                            {property: 'og:image', content: this.articleImage},
                            {property: 'vk:image', content: this.articleImage}
                        ]
                    }
                } else {
                    return {
                        title: 'Astrodesign',
                        meta: []
                    }
                }
            },

            articleUrl() {
                return process.env.VUE_APP_FRONT_GLOBAL_URL + this.$route.path;
            },

            articleImage() {
                if (!!this.article && !!this.article.hasImage)
                    return process.env.VUE_APP_GLOBAL_URL + `/document/article-image/${this.article.id}`;
                else
                    return this.defaultArticleImage;
            },

            userLoggedIn() {
                let token = this.$store.getters.token;
                return !!token && token.length > 0;
            },

            currentSubscription() {
                return this.$store.getters.currentSubscription;
            },

            onlyProAccess() {
                return this.article.status === constants.articleStatus.ONLY_PRO
                        && (!this.currentSubscription || this.currentSubscription.tariff !== constants.tariff.PRO)
            },

            onlyPaidAccess() {
                return this.article.status === constants.articleStatus.ONLY_PAID
                        && (!this.currentSubscription || ![constants.tariff.STANDARD, constants.tariff.PRO].includes(this.currentSubscription.tariff));
            },

            onlyAuthAccess() {
                return this.article.status === constants.articleStatus.ONLY_AUTH
                        && !this.userLoggedIn
            }
        },

        async created() {
            if (!!this.userLoggedIn) {
                await this.$store.dispatch('getCurrentSubscription');
            }

            let code = this.$route.params.code;
            if (!code || code.length == 0) {
                this.$router.push({name: 'Blog'});
                return;
            }

            let article = await this.loadArticle(code);
            if (!article) {
                this.$router.push({name: 'Blog'});
                return;
            }

            this.article = article;
        },

        methods: {
            async loadArticle(code) {
                return await this.$store.dispatch('getArticleByCode', code);
            },

            formatDate(date) {
                return moment(date).format("DD.MM.YYYY");
            },

            shareVk() {
                Share.vkontakte(this.articleUrl, this.article.header, this.articleImage);
            },

            shareFb() {
                Share.facebook(this.articleUrl, this.article.header, this.articleImage);
            }
        }
    }
</script>